module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_1_G.20e48a6a.mp3";